import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const removeInjectedWatermark = () => {
  document.querySelectorAll("a, div").forEach((element) => {
    const text = (element.textContent || "").trim();
    if (!text.startsWith("Made with")) {
      return;
    }

    const style = window.getComputedStyle(element);
    const isOverlayBadge = style.position === "fixed" && Number.parseInt(style.right, 10) >= 0;
    if (!isOverlayBadge) {
      return;
    }

    const linkContainer = element.closest("a");
    if (linkContainer && window.getComputedStyle(linkContainer).position === "fixed") {
      linkContainer.remove();
      return;
    }

    element.remove();
  });
};

removeInjectedWatermark();
const badgeObserver = new MutationObserver(removeInjectedWatermark);
badgeObserver.observe(document.documentElement, { childList: true, subtree: true });
window.addEventListener("beforeunload", () => badgeObserver.disconnect());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
